export const cities = [
    'Adilabad, Andhra Pradesh (AP)',
    'Anantapur, Andhra Pradesh (AP)',
    'Chittoor, Andhra Pradesh (AP)',
    'Kakinada, Andhra Pradesh (AP)',
    'Guntur, Andhra Pradesh (AP)',
    'Hyderabad, Andhra Pradesh (AP)',
    'Karimnagar, Andhra Pradesh (AP)',
    'Khammam, Andhra Pradesh (AP)',
    'Krishna, Andhra Pradesh (AP)',
    'Kurnool, Andhra Pradesh (AP)',
    'Mahbubnagar, Andhra Pradesh (AP)',
    'Medak, Andhra Pradesh (AP)',
    'Nalgonda, Andhra Pradesh (AP)',
    'Nizamabad, Andhra Pradesh (AP)',
    'Ongole, Andhra Pradesh (AP)',
    'Hyderabad, Andhra Pradesh (AP)',
    'Srikakulam, Andhra Pradesh (AP)',
    'Nellore, Andhra Pradesh (AP)',
    'Visakhapatnam, Andhra Pradesh (AP)',
    'Vizianagaram, Andhra Pradesh (AP)',
    'Warangal, Andhra Pradesh (AP)',
    'Eluru, Andhra Pradesh (AP)',
    'Kadapa, Andhra Pradesh (AP)',
    'Anjaw, Arunachal Pradesh (AR)',
    'Changlang, Arunachal Pradesh (AR)',
    'East Siang, Arunachal Pradesh (AR)',
    'Kurung Kumey, Arunachal Pradesh (AR)',
    'Lohit, Arunachal Pradesh (AR)',
    'Lower Dibang Valley, Arunachal Pradesh (AR)',
    'Lower Subansiri, Arunachal Pradesh (AR)',
    'Papum Pare, Arunachal Pradesh (AR)',
    'Tawang, Arunachal Pradesh (AR)',
    'Tirap, Arunachal Pradesh (AR)',
    'Dibang Valley, Arunachal Pradesh (AR)',
    'Upper Siang, Arunachal Pradesh (AR)',
    'Upper Subansiri, Arunachal Pradesh (AR)',
    'West Kameng, Arunachal Pradesh (AR)',
    'West Siang, Arunachal Pradesh (AR)',
    'Baksa, Assam (AS)',
    'Barpeta, Assam (AS)',
    'Bongaigaon, Assam (AS)',
    'Cachar, Assam (AS)',
    'Chirang, Assam (AS)',
    'Darrang, Assam (AS)',
    'Dhemaji, Assam (AS)',
    'Dima Hasao, Assam (AS)',
    'Dhubri, Assam (AS)',
    'Dibrugarh, Assam (AS)',
    'Goalpara, Assam (AS)',
    'Golaghat, Assam (AS)',
    'Hailakandi, Assam (AS)',
    'Jorhat, Assam (AS)',
    'Kamrup, Assam (AS)',
    'Kamrup Metropolitan, Assam (AS)',
    'Karbi Anglong, Assam (AS)',
    'Karimganj, Assam (AS)',
    'Kokrajhar, Assam (AS)',
    'Lakhimpur, Assam (AS)',
    'Marigaon, Assam (AS)',
    'Nagaon, Assam (AS)',
    'Nalbari, Assam (AS)',
    'Sibsagar, Assam (AS)',
    'Sonitpur, Assam (AS)',
    'Tinsukia, Assam (AS)',
    'Udalguri, Assam (AS)',
    'Araria, Bihar (BR)',
    'Arwal, Bihar (BR)',
    'Aurangabad, Bihar (BR)',
    'Banka, Bihar (BR)',
    'Begusarai, Bihar (BR)',
    'Bhagalpur, Bihar (BR)',
    'Bhojpur, Bihar (BR)',
    'Buxar, Bihar (BR)',
    'Darbhanga, Bihar (BR)',
    'East Champaran, Bihar (BR)',
    'Gaya, Bihar (BR)',
    'Gopalganj, Bihar (BR)',
    'Jamui, Bihar (BR)',
    'Jehanabad, Bihar (BR)',
    'Kaimur, Bihar (BR)',
    'Katihar, Bihar (BR)',
    'Khagaria, Bihar (BR)',
    'Kishanganj, Bihar (BR)',
    'Lakhisarai, Bihar (BR)',
    'Madhepura, Bihar (BR)',
    'Madhubani, Bihar (BR)',
    'Munger, Bihar (BR)',
    'Muzaffarpur, Bihar (BR)',
    'Nalanda, Bihar (BR)',
    'Nawada, Bihar (BR)',
    'Patna, Bihar (BR)',
    'Purnia, Bihar (BR)',
    'Rohtas, Bihar (BR)',
    'Saharsa, Bihar (BR)',
    'Samastipur, Bihar (BR)',
    'Saran, Bihar (BR)',
    'Sheikhpura, Bihar (BR)',
    'Sheohar, Bihar (BR)',
    'Sitamarhi, Bihar (BR)',
    'Siwan, Bihar (BR)',
    'Supaul, Bihar (BR)',
    'Vaishali, Bihar (BR)',
    'West Champaran, Bihar (BR)',
    'Chandigarh, Bihar (BR)',
    'Bastar, Chhattisgarh (CG)',
    'Bijapur, Chhattisgarh (CG)',
    'Bilaspur, Chhattisgarh (CG)',
    'Dantewada, Chhattisgarh (CG)',
    'Dhamtari, Chhattisgarh (CG)',
    'Durg, Chhattisgarh (CG)',
    'Jashpur, Chhattisgarh (CG)',
    'Janjgir-Champa, Chhattisgarh (CG)',
    'Korba, Chhattisgarh (CG)',
    'Koriya, Chhattisgarh (CG)',
    'Kanker, Chhattisgarh (CG)',
    'Kabirdham (Kawardha), Chhattisgarh (CG)',
    'Mahasamund, Chhattisgarh (CG)',
    'Narayanpur, Chhattisgarh (CG)',
    'Raigarh, Chhattisgarh (CG)',
    'Rajnandgaon, Chhattisgarh (CG)',
    'Raipur, Chhattisgarh (CG)',
    'Surguja, Chhattisgarh (CG)',
    'Dadra and Nagar Haveli, Dadra and Nagar Haveli (DN)',
    'Daman, Daman and Diu (DD)',
    'Diu, Daman and Diu (DD)',
    'Central Delhi, Delhi (DL)',
    'East Delhi, Delhi (DL)',
    'New Delhi, Delhi (DL)',
    'North Delhi, Delhi (DL)',
    'North East Delhi, Delhi (DL)',
    'North West Delhi, Delhi (DL)',
    'South Delhi, Delhi (DL)',
    'South West Delhi, Delhi (DL)',
    'West Delhi, Delhi (DL)',
    'North Goa, Goa (GA)',
    'South Goa, Goa (GA)',
    'Ahmedabad, Gujarat (GJ)',
    'Amreli district, Gujarat (GJ)',
    'Anand, Gujarat (GJ)',
    'Banaskantha, Gujarat (GJ)',
    'Bharuch, Gujarat (GJ)',
    'Bhavnagar, Gujarat (GJ)',
    'Dahod, Gujarat (GJ)',
    'The Dangs, Gujarat (GJ)',
    'Gandhinagar, Gujarat (GJ)',
    'Jamnagar, Gujarat (GJ)',
    'Junagadh, Gujarat (GJ)',
    'Kutch, Gujarat (GJ)',
    'Kheda, Gujarat (GJ)',
    'Mehsana, Gujarat (GJ)',
    'Narmada, Gujarat (GJ)',
    'Navsari, Gujarat (GJ)',
    'Patan, Gujarat (GJ)',
    'Panchmahal, Gujarat (GJ)',
    'Porbandar, Gujarat (GJ)',
    'Rajkot, Gujarat (GJ)',
    'Sabarkantha, Gujarat (GJ)',
    'Surendranagar, Gujarat (GJ)',
    'Surat, Gujarat (GJ)',
    'Vyara, Gujarat (GJ)',
    'Vadodara, Gujarat (GJ)',
    'Valsad, Gujarat (GJ)',
    'Ambala, Haryana (HR)',
    'Bhiwani, Haryana (HR)',
    'Faridabad, Haryana (HR)',
    'Fatehabad, Haryana (HR)',
    'Gurgaon, Haryana (HR)',
    'Hissar, Haryana (HR)',
    'Jhajjar, Haryana (HR)',
    'Jind, Haryana (HR)',
    'Karnal, Haryana (HR)',
    'Kaithal, Haryana (HR)',
    'Kurukshetra, Haryana (HR)',
    'Mahendragarh, Haryana (HR)',
    'Mewat, Haryana (HR)',
    'Palwal, Haryana (HR)',
    'Panchkula, Haryana (HR)',
    'Panipat, Haryana (HR)',
    'Rewari, Haryana (HR)',
    'Rohtak, Haryana (HR)',
    'Sirsa, Haryana (HR)',
    'Sonipat, Haryana (HR)',
    'Yamuna Nagar, Haryana (HR)',
    'Bilaspur, Himachal Pradesh (HP)',
    'Chamba, Himachal Pradesh (HP)',
    'Hamirpur, Himachal Pradesh (HP)',
    'Kangra, Himachal Pradesh (HP)',
    'Kinnaur, Himachal Pradesh (HP)',
    'Kullu, Himachal Pradesh (HP)',
    'Lahaul and Spiti, Himachal Pradesh (HP)',
    'Mandi, Himachal Pradesh (HP)',
    'Shimla, Himachal Pradesh (HP)',
    'Sirmaur, Himachal Pradesh (HP)',
    'Solan, Himachal Pradesh (HP)',
    'Una, Himachal Pradesh (HP)',
    'Anantnag, Jammu and Kashmir (JK)',
    'Badgam, Jammu and Kashmir (JK)',
    'Bandipora, Jammu and Kashmir (JK)',
    'Baramulla, Jammu and Kashmir (JK)',
    'Doda, Jammu and Kashmir (JK)',
    'Ganderbal, Jammu and Kashmir (JK)',
    'Jammu, Jammu and Kashmir (JK)',
    'Kargil, Jammu and Kashmir (JK)',
    'Kathua, Jammu and Kashmir (JK)',
    'Kishtwar, Jammu and Kashmir (JK)',
    'Kupwara, Jammu and Kashmir (JK)',
    'Kulgam, Jammu and Kashmir (JK)',
    'Leh, Jammu and Kashmir (JK)',
    'Poonch, Jammu and Kashmir (JK)',
    'Pulwama, Jammu and Kashmir (JK)',
    'Rajauri, Jammu and Kashmir (JK)',
    'Ramban, Jammu and Kashmir (JK)',
    'Reasi, Jammu and Kashmir (JK)',
    'Samba, Jammu and Kashmir (JK)',
    'Shopian, Jammu and Kashmir (JK)',
    'Srinagar, Jammu and Kashmir (JK)',
    'Udhampur, Jammu and Kashmir (JK)',
    'Bokaro, Jharkhand (JH)',
    'Chatra, Jharkhand (JH)',
    'Deoghar, Jharkhand (JH)',
    'Dhanbad, Jharkhand (JH)',
    'Dumka, Jharkhand (JH)',
    'East Singhbhum, Jharkhand (JH)',
    'Garhwa, Jharkhand (JH)',
    'Giridih, Jharkhand (JH)',
    'Godda, Jharkhand (JH)',
    'Gumla, Jharkhand (JH)',
    'Hazaribag, Jharkhand (JH)',
    'Jamtara, Jharkhand (JH)',
    'Khunti, Jharkhand (JH)',
    'Koderma, Jharkhand (JH)',
    'Latehar, Jharkhand (JH)',
    'Lohardaga, Jharkhand (JH)',
    'Pakur, Jharkhand (JH)',
    'Palamu, Jharkhand (JH)',
    'Ramgarh, Jharkhand (JH)',
    'Ranchi, Jharkhand (JH)',
    'Sahibganj, Jharkhand (JH)',
    'Seraikela Kharsawan, Jharkhand (JH)',
    'Simdega, Jharkhand (JH)',
    'West Singhbhum, Jharkhand (JH)',
    'Bagalkot, Karnataka (KA)',
    'Bangalore Rural, Karnataka (KA)',
    'Bangalore Urban, Karnataka (KA)',
    'Belgaum, Karnataka (KA)',
    'Bellary, Karnataka (KA)',
    'Bidar, Karnataka (KA)',
    'Bijapur, Karnataka (KA)',
    'Chamarajnagar, Karnataka (KA)',
    'Chikkamagaluru, Karnataka (KA)',
    'Chikkaballapur, Karnataka (KA)',
    'Chitradurga, Karnataka (KA)',
    'Davanagere, Karnataka (KA)',
    'Dharwad, Karnataka (KA)',
    'Dakshina Kannada, Karnataka (KA)',
    'Gadag, Karnataka (KA)',
    'Gulbarga, Karnataka (KA)',
    'Hassan, Karnataka (KA)',
    'Haveri district, Karnataka (KA)',
    'Kodagu, Karnataka (KA)',
    'Kolar, Karnataka (KA)',
    'Koppal, Karnataka (KA)',
    'Mandya, Karnataka (KA)',
    'Mysore, Karnataka (KA)',
    'Raichur, Karnataka (KA)',
    'Shimoga, Karnataka (KA)',
    'Tumkur, Karnataka (KA)',
    'Udupi, Karnataka (KA)',
    'Uttara Kannada, Karnataka (KA)',
    'Ramanagara, Karnataka (KA)',
    'Yadgir, Karnataka (KA)',
    'Alappuzha, Kerala (KL)',
    'Ernakulam, Kerala (KL)',
    'Idukki, Kerala (KL)',
    'Kannur, Kerala (KL)',
    'Kasaragod, Kerala (KL)',
    'Kollam, Kerala (KL)',
    'Kottayam, Kerala (KL)',
    'Kozhikode, Kerala (KL)',
    'Malappuram, Kerala (KL)',
    'Palakkad, Kerala (KL)',
    'Pathanamthitta, Kerala (KL)',
    'Thrissur, Kerala (KL)',
    'Thiruvananthapuram, Kerala (KL)',
    'Wayanad, Kerala (KL)',
    'Alirajpur, Madhya Pradesh (MP)',
    'Anuppur, Madhya Pradesh (MP)',
    'Ashok Nagar, Madhya Pradesh (MP)',
    'Balaghat, Madhya Pradesh (MP)',
    'Barwani, Madhya Pradesh (MP)',
    'Betul, Madhya Pradesh (MP)',
    'Bhind, Madhya Pradesh (MP)',
    'Bhopal, Madhya Pradesh (MP)',
    'Burhanpur, Madhya Pradesh (MP)',
    'Chhatarpur, Madhya Pradesh (MP)',
    'Chhindwara, Madhya Pradesh (MP)',
    'Damoh, Madhya Pradesh (MP)',
    'Datia, Madhya Pradesh (MP)',
    'Dewas, Madhya Pradesh (MP)',
    'Dhar, Madhya Pradesh (MP)',
    'Dindori, Madhya Pradesh (MP)',
    'Guna, Madhya Pradesh (MP)',
    'Gwalior, Madhya Pradesh (MP)',
    'Harda, Madhya Pradesh (MP)',
    'Hoshangabad, Madhya Pradesh (MP)',
    'Indore, Madhya Pradesh (MP)',
    'Jabalpur, Madhya Pradesh (MP)',
    'Jhabua, Madhya Pradesh (MP)',
    'Katni, Madhya Pradesh (MP)',
    'Khandwa (East Nimar), Madhya Pradesh (MP)',
    'Khargone (West Nimar), Madhya Pradesh (MP)',
    'Mandla, Madhya Pradesh (MP)',
    'Mandsaur, Madhya Pradesh (MP)',
    'Morena, Madhya Pradesh (MP)',
    'Narsinghpur, Madhya Pradesh (MP)',
    'Neemuch, Madhya Pradesh (MP)',
    'Panna, Madhya Pradesh (MP)',
    'Rewa, Madhya Pradesh (MP)',
    'Rajgarh, Madhya Pradesh (MP)',
    'Ratlam, Madhya Pradesh (MP)',
    'Raisen, Madhya Pradesh (MP)',
    'Sagar, Madhya Pradesh (MP)',
    'Satna, Madhya Pradesh (MP)',
    'Sehore, Madhya Pradesh (MP)',
    'Seoni, Madhya Pradesh (MP)',
    'Shahdol, Madhya Pradesh (MP)',
    'Shajapur, Madhya Pradesh (MP)',
    'Sheopur, Madhya Pradesh (MP)',
    'Shivpuri, Madhya Pradesh (MP)',
    'Sidhi, Madhya Pradesh (MP)',
    'Singrauli, Madhya Pradesh (MP)',
    'Tikamgarh, Madhya Pradesh (MP)',
    'Ujjain, Madhya Pradesh (MP)',
    'Umaria, Madhya Pradesh (MP)',
    'Vidisha, Madhya Pradesh (MP)',
    'Ahmednagar, Maharashtra (MH)',
    'Akola, Maharashtra (MH)',
    'Amravati, Maharashtra (MH)',
    'Aurangabad, Maharashtra (MH)',
    'Bhandara, Maharashtra (MH)',
    'Beed, Maharashtra (MH)',
    'Buldhana, Maharashtra (MH)',
    'Chandrapur, Maharashtra (MH)',
    'Dhule, Maharashtra (MH)',
    'Gadchiroli, Maharashtra (MH)',
    'Gondia, Maharashtra (MH)',
    'Hingoli, Maharashtra (MH)',
    'Jalgaon, Maharashtra (MH)',
    'Jalna, Maharashtra (MH)',
    'Kolhapur, Maharashtra (MH)',
    'Latur, Maharashtra (MH)',
    'Mumbai City, Maharashtra (MH)',
    'Mumbai suburban, Maharashtra (MH)',
    'Nandurbar, Maharashtra (MH)',
    'Nanded, Maharashtra (MH)',
    'Nagpur, Maharashtra (MH)',
    'Nashik, Maharashtra (MH)',
    'Osmanabad, Maharashtra (MH)',
    'Parbhani, Maharashtra (MH)',
    'Pune, Maharashtra (MH)',
    'Raigad, Maharashtra (MH)',
    'Ratnagiri, Maharashtra (MH)',
    'Sindhudurg, Maharashtra (MH)',
    'Sangli, Maharashtra (MH)',
    'Solapur, Maharashtra (MH)',
    'Satara, Maharashtra (MH)',
    'Thane, Maharashtra (MH)',
    'Wardha, Maharashtra (MH)',
    'Washim, Maharashtra (MH)',
    'Yavatmal, Maharashtra (MH)',
    'Bishnupur, Manipur (MN)',
    'Churachandpur, Manipur (MN)',
    'Chandel, Manipur (MN)',
    'Imphal East, Manipur (MN)',
    'Senapati, Manipur (MN)',
    'Tamenglong, Manipur (MN)',
    'Thoubal, Manipur (MN)',
    'Ukhrul, Manipur (MN)',
    'Imphal West, Manipur (MN)',
    'East Garo Hills, Meghalaya (ML)',
    'East Khasi Hills, Meghalaya (ML)',
    'Jaintia Hills, Meghalaya (ML)',
    'Ri Bhoi, Meghalaya (ML)',
    'South Garo Hills, Meghalaya (ML)',
    'West Garo Hills, Meghalaya (ML)',
    'West Khasi Hills, Meghalaya (ML)',
    'Aizawl, Mizoram (MZ)',
    'Champhai, Mizoram (MZ)',
    'Kolasib, Mizoram (MZ)',
    'Lawngtlai, Mizoram (MZ)',
    'Lunglei, Mizoram (MZ)',
    'Mamit, Mizoram (MZ)',
    'Saiha, Mizoram (MZ)',
    'Serchhip, Mizoram (MZ)',
    'Dimapur, Nagaland (NL)',
    'Kohima, Nagaland (NL)',
    'Mokokchung, Nagaland (NL)',
    'Mon, Nagaland (NL)',
    'Phek, Nagaland (NL)',
    'Tuensang, Nagaland (NL)',
    'Wokha, Nagaland (NL)',
    'Zunheboto, Nagaland (NL)',
    'Angul, Orissa (OR)',
    'Boudh (Bauda), Orissa (OR)',
    'Bhadrak, Orissa (OR)',
    'Balangir, Orissa (OR)',
    'Bargarh (Baragarh), Orissa (OR)',
    'Balasore, Orissa (OR)',
    'Cuttack, Orissa (OR)',
    'Debagarh (Deogarh), Orissa (OR)',
    'Dhenkanal, Orissa (OR)',
    'Ganjam, Orissa (OR)',
    'Gajapati, Orissa (OR)',
    'Jharsuguda, Orissa (OR)',
    'Jajpur, Orissa (OR)',
    'Jagatsinghpur, Orissa (OR)',
    'Khordha, Orissa (OR)',
    'Kendujhar (Keonjhar), Orissa (OR)',
    'Kalahandi, Orissa (OR)',
    'Kandhamal, Orissa (OR)',
    'Koraput, Orissa (OR)',
    'Kendrapara, Orissa (OR)',
    'Malkangiri, Orissa (OR)',
    'Mayurbhanj, Orissa (OR)',
    'Nabarangpur, Orissa (OR)',
    'Nuapada, Orissa (OR)',
    'Nayagarh, Orissa (OR)',
    'Puri, Orissa (OR)',
    'Rayagada, Orissa (OR)',
    'Sambalpur, Orissa (OR)',
    'Subarnapur (Sonepur), Orissa (OR)',
    'Sundergarh, Orissa (OR)',
    'Karaikal, Pondicherry (Puducherry) (PY)',
    'Mahe, Pondicherry (Puducherry) (PY)',
    'Pondicherry, Pondicherry (Puducherry) (PY)',
    'Yanam, Pondicherry (Puducherry) (PY)',
    'Amritsar, Punjab (PB)',
    'Barnala, Punjab (PB)',
    'Bathinda, Punjab (PB)',
    'Firozpur, Punjab (PB)',
    'Faridkot, Punjab (PB)',
    'Fatehgarh Sahib, Punjab (PB)',
    'Fazilka, Punjab (PB)',
    'Gurdaspur, Punjab (PB)',
    'Hoshiarpur, Punjab (PB)',
    'Jalandhar, Punjab (PB)',
    'Kapurthala, Punjab (PB)',
    'Ludhiana, Punjab (PB)',
    'Mansa, Punjab (PB)',
    'Moga, Punjab (PB)',
    'Sri Muktsar Sahib, Punjab (PB)',
    'Pathankot, Punjab (PB)',
    'Patiala, Punjab (PB)',
    'Rupnagar, Punjab (PB)',
    'Ajitgarh (Mohali), Punjab (PB)',
    'Sangrur, Punjab (PB)',
    'Nawanshahr, Punjab (PB)',
    'Tarn Taran, Punjab (PB)',
    'Ajmer, Rajasthan (RJ)',
    'Alwar, Rajasthan (RJ)',
    'Bikaner, Rajasthan (RJ)',
    'Barmer, Rajasthan (RJ)',
    'Banswara, Rajasthan (RJ)',
    'Bharatpur, Rajasthan (RJ)',
    'Baran, Rajasthan (RJ)',
    'Bundi, Rajasthan (RJ)',
    'Bhilwara, Rajasthan (RJ)',
    'Churu, Rajasthan (RJ)',
    'Chittorgarh, Rajasthan (RJ)',
    'Dausa, Rajasthan (RJ)',
    'Dholpur, Rajasthan (RJ)',
    'Dungapur, Rajasthan (RJ)',
    'Ganganagar, Rajasthan (RJ)',
    'Hanumangarh, Rajasthan (RJ)',
    'Jhunjhunu, Rajasthan (RJ)',
    'Jalore, Rajasthan (RJ)',
    'Jodhpur, Rajasthan (RJ)',
    'Jaipur, Rajasthan (RJ)',
    'Jaisalmer, Rajasthan (RJ)',
    'Jhalawar, Rajasthan (RJ)',
    'Karauli, Rajasthan (RJ)',
    'Kota, Rajasthan (RJ)',
    'Nagaur, Rajasthan (RJ)',
    'Pali, Rajasthan (RJ)',
    'Pratapgarh, Rajasthan (RJ)',
    'Rajsamand, Rajasthan (RJ)',
    'Sikar, Rajasthan (RJ)',
    'Sawai Madhopur, Rajasthan (RJ)',
    'Sirohi, Rajasthan (RJ)',
    'Tonk, Rajasthan (RJ)',
    'Udaipur, Rajasthan (RJ)',
    'East Sikkim, Sikkim (SK)',
    'North Sikkim, Sikkim (SK)',
    'South Sikkim, Sikkim (SK)',
    'West Sikkim, Sikkim (SK)',
    'Ariyalur, Tamil Nadu (TN)',
    'Chennai, Tamil Nadu (TN)',
    'Coimbatore, Tamil Nadu (TN)',
    'Cuddalore, Tamil Nadu (TN)',
    'Dharmapuri, Tamil Nadu (TN)',
    'Dindigul, Tamil Nadu (TN)',
    'Erode, Tamil Nadu (TN)',
    'Kanchipuram, Tamil Nadu (TN)',
    'Kanyakumari, Tamil Nadu (TN)',
    'Karur, Tamil Nadu (TN)',
    'Madurai, Tamil Nadu (TN)',
    'Nagapattinam, Tamil Nadu (TN)',
    'Nilgiris, Tamil Nadu (TN)',
    'Namakkal, Tamil Nadu (TN)',
    'Perambalur, Tamil Nadu (TN)',
    'Pudukkottai, Tamil Nadu (TN)',
    'Ramanathapuram, Tamil Nadu (TN)',
    'Salem, Tamil Nadu (TN)',
    'Sivaganga, Tamil Nadu (TN)',
    'Tirupur, Tamil Nadu (TN)',
    'Tiruchirappalli, Tamil Nadu (TN)',
    'Theni, Tamil Nadu (TN)',
    'Tirunelveli, Tamil Nadu (TN)',
    'Thanjavur, Tamil Nadu (TN)',
    'Thoothukudi, Tamil Nadu (TN)',
    'Tiruvallur, Tamil Nadu (TN)',
    'Tiruvarur, Tamil Nadu (TN)',
    'Tiruvannamalai, Tamil Nadu (TN)',
    'Vellore, Tamil Nadu (TN)',
    'Viluppuram, Tamil Nadu (TN)',
    'Virudhunagar, Tamil Nadu (TN)',
    'Dhalai, Tripura (TR)',
    'North Tripura, Tripura (TR)',
    'South Tripura, Tripura (TR)',
    'Khowai, Tripura (TR)',
    'West Tripura, Tripura (TR)',
    'Agra, Uttar Pradesh (UP)',
    'Allahabad, Uttar Pradesh (UP)',
    'Aligarh, Uttar Pradesh (UP)',
    'Ambedkar Nagar, Uttar Pradesh (UP)',
    'Auraiya, Uttar Pradesh (UP)',
    'Azamgarh, Uttar Pradesh (UP)',
    'Barabanki, Uttar Pradesh (UP)',
    'Budaun, Uttar Pradesh (UP)',
    'Bagpat, Uttar Pradesh (UP)',
    'Bahraich, Uttar Pradesh (UP)',
    'Bijnor, Uttar Pradesh (UP)',
    'Ballia, Uttar Pradesh (UP)',
    'Banda, Uttar Pradesh (UP)',
    'Balrampur, Uttar Pradesh (UP)',
    'Bareilly, Uttar Pradesh (UP)',
    'Basti, Uttar Pradesh (UP)',
    'Bulandshahr Uttar Pradesh (UP)',
    'Chandauli, Uttar Pradesh (UP)',
    'Chhatrapati Shahuji Maharaj Nagar, Uttar Pradesh (UP)',
    'Chitrakoot, Uttar Pradesh (UP)',
    'Deoria, Uttar Pradesh (UP)',
    'Etah, Uttar Pradesh (UP)',
    'Kanshi Ram Nagar, Uttar Pradesh (UP)',
    'Etawah, Uttar Pradesh (UP)',
    'Firozabad, Uttar Pradesh (UP)',
    'Farrukhabad, Uttar Pradesh (UP)',
    'Fatehpur, Uttar Pradesh (UP)',
    'Faizabad, Uttar Pradesh (UP)',
    'Gautam Buddh Nagar, Uttar Pradesh (UP)',
    'Gonda, Uttar Pradesh (UP)',
    'Ghazipur, Uttar Pradesh (UP)',
    'Gorakhpur, Uttar Pradesh (UP)',
    'Ghaziabad, Uttar Pradesh (UP)',
    'Hamirpur, Uttar Pradesh (UP)',
    'Hardoi, Uttar Pradesh (UP)',
    'Mahamaya Nagar, Uttar Pradesh (UP)',
    'Jhansi, Uttar Pradesh (UP)',
    'Jalaun, Uttar Pradesh (UP)',
    'Jyotiba Phule Nagar, Uttar Pradesh (UP)',
    'Jaunpur district, Uttar Pradesh (UP)',
    'Ramabai Nagar (Kanpur Dehat), Uttar Pradesh (UP)',
    'Kannauj, Uttar Pradesh (UP)',
    'Kanpur, Uttar Pradesh (UP)',
    'Kaushambi, Uttar Pradesh (UP)',
    'Kushinagar, Uttar Pradesh (UP)',
    'Lalitpur, Uttar Pradesh (UP)',
    'Lakhimpur Kheri, Uttar Pradesh (UP)',
    'Lucknow, Uttar Pradesh (UP)',
    'Mau, Uttar Pradesh (UP)',
    'Meerut, Uttar Pradesh (UP)',
    'Maharajganj, Uttar Pradesh (UP)',
    'Mahoba, Uttar Pradesh (UP)',
    'Mirzapur, Uttar Pradesh (UP)',
    'Moradabad, Uttar Pradesh (UP)',
    'Mainpuri, Uttar Pradesh (UP)',
    'Mathura, Uttar Pradesh (UP)',
    'Muzaffarnagar, Uttar Pradesh (UP)',
    'Panchsheel Nagar district (Hapur), Uttar Pradesh (UP)',
    'Pilibhit, Uttar Pradesh (UP)',
    'Shamli, Uttar Pradesh (UP)',
    'Pratapgarh, Uttar Pradesh (UP)',
    'Rampur, Uttar Pradesh (UP)',
    'Raebareli, Uttar Pradesh (UP)',
    'Saharanpur, Uttar Pradesh (UP)',
    'Sitapur, Uttar Pradesh (UP)',
    'Shahjahanpur, Uttar Pradesh (UP)',
    'Sant Kabir Nagar, Uttar Pradesh (UP)',
    'Siddharthnagar, Uttar Pradesh (UP)',
    'Sonbhadra, Uttar Pradesh (UP)',
    'Sant Ravidas Nagar, Uttar Pradesh (UP)',
    'Sultanpur, Uttar Pradesh (UP)',
    'Shravasti, Uttar Pradesh (UP)',
    'Unnao, Uttar Pradesh (UP)',
    'Varanasi, Uttar Pradesh (UP)',
    'Almora, Uttarakhand (UK)',
    'Bageshwar, Uttarakhand (UK)',
    'Chamoli, Uttarakhand (UK)',
    'Champawat, Uttarakhand (UK)',
    'Dehradun, Uttarakhand (UK)',
    'Haridwar, Uttarakhand (UK)',
    'Nainital, Uttarakhand (UK)',
    'Pauri Garhwal, Uttarakhand (UK)',
    'Pithoragarh, Uttarakhand (UK)',
    'Rudraprayag, Uttarakhand (UK)',
    'Tehri Garhwal, Uttarakhand (UK)',
    'Udham Singh Nagar, Uttarakhand (UK)',
    'Uttarkashi, Uttarakhand (UK)',
    'Birbhum, West Bengal (WB)',
    'Bankura, West Bengal (WB)',
    'Bardhaman, West Bengal (WB)',
    'Darjeeling, West Bengal (WB)',
    'Dakshin Dinajpur, West Bengal (WB)',
    'Hooghly, West Bengal (WB)',
    'Howrah, West Bengal (WB)',
    'Jalpaiguri, West Bengal (WB)',
    'Cooch Behar, West Bengal (WB)',
    'Kolkata, West Bengal (WB)',
    'Maldah, West Bengal (WB)',
    'Paschim Medinipur, West Bengal (WB)',
    'Purba Medinipur, West Bengal (WB)',
    'Murshidabad, West Bengal (WB)',
    'Nadia, West Bengal (WB)',
    'North 24 Parganas, West Bengal (WB)',
    'South 24 Parganas, West Bengal (WB)',
    'Purulia, West Bengal (WB)',
    'Uttar Dinajpur, West Bengal (WB)',
]